<template>
  <vs-card>
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full md:w-1/4 px-8">
        <form method="POST" @submit.prevent="save_changes">
          <!-- Name -->
          <div class="vx-row mb-3">
            <label class="vs-input--label">Select Month *</label>
            <select-2
              class="w-full"
              name="Month Name"
              placeholder="Select Month"
              :value="form.month_name"
              @input="(item) => (form.month_name = item && item.value)"
              autocomplete
              :ssr="true"
              v-validate="'required'"
              :options="monthTypes"
            />
            <span class="text-danger text-sm" v-show="errors.has('Month Name')">{{ errors.first('Month Name') }}</span>
          </div>

          <!-- Start Date -->
          <div class="vx-row mb-3">
            <label class="vs-input--label">Start Date *</label>
            <flat-pickr @input="selectStartDate($event)" v-model="form.start_date" id="Start Date" name="Start Date" v-validate="'required'" placeholder="Select Start Date" class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('Start Date')">{{ errors.first('Start Date') }}</span>
          </div>

          <!-- End Date -->
          <div class="vx-row mb-3">
            <label class="vs-input--label">End Date *</label>
            <flat-pickr @input="selectEndDate($event)" v-model="form.end_date" id="End Date" name="End Date" v-validate="'required'" placeholder="Select End Date" class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('End Date')">{{ errors.first('End Date') }}</span>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex flex-wrap items-center justify-start">
                <vs-button class="mr-2 vs-con-loading__container" id="create" @click="save_changes">{{ $route.params.id ? 'Update' : 'Add' }}</vs-button>
                <vs-button @click="navigateToList" color="danger" class="text-white-500">Cancel</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </vs-card>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import 'flatpickr/dist/flatpickr.css'
import flatPickr from 'vue-flatpickr-component'
import { mapActions, mapState } from 'vuex'

export default {
  /** Page Name */
  name: 'AddUpdate',

  /** data */
  data() {
    return {
      breadcrumb: [],
      form: {
        month_name: null,
        start_date: null,
        end_date: null
      }
    }
  },

  components: {
    flatPickr,
    Select2
  },

  /** computed */
  computed: {
    ...mapState('month', ['createLoading', 'monthTypes']),
    validateForm() {
      return !this.errors.any()
    }
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('month/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data

        /** breadcrumb implement  */
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Month', url: '/month/list' },
          { title: `Edit ${data.month_name}`, active: true }
        ]
        this.form.month_name = data.month_name
        this.form.start_date = data.start_date
        this.form.end_date = data.end_date
      })
    }
  },

  /** methods */
  methods: {
    ...mapActions('month', {
      create: 'create',
      update: 'update'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data: this.form
          })
        } else {
          response = await this.create(this.form)
        }
        this.$router.push({
          name: 'month-list'
        })
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** navigate to List */
    navigateToList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'month-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    /** Date Selection */
    selectStartDate(event) {
      this.form.start_date = event
    },
    selectEndDate(event) {
      this.form.end_date = event
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create > .con-vs-loading')
      }
    }
  }
}
</script>

<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}

.color {
  background-image: none !important;
}
</style>
